import { render, staticRenderFns } from "./Aprendizado.vue?vue&type=template&id=1b7b9bf4&"
import script from "./Aprendizado.vue?vue&type=script&lang=js&"
export * from "./Aprendizado.vue?vue&type=script&lang=js&"
import style0 from "./Aprendizado.vue?vue&type=style&index=0&id=1b7b9bf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports